var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xnomfrsfda)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.001 21.59v45.485a10.001 10.001 0 0 1-10.007 10.007H10.675c-.91 0-1.783-.11-2.584-.364a9.959 9.959 0 0 1-7.423-9.643V21.589a10.001 10.001 0 0 1 10.007-10.007h67.32A10.001 10.001 0 0 1 88 21.589z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.14 29.778a7.277 7.277 0 0 1-14.556 0 7.278 7.278 0 1 1 14.555 0z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 58.669v8.405a10.001 10.001 0 0 1-10.006 10.007h-67.32c-.91 0-1.782-.109-2.583-.363L52.558 32.25c2.474-2.474 6.55-2.474 9.025 0L88 58.669z",
    fill: "#388E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.747 77.082H10.675c-.91 0-1.783-.11-2.584-.364a9.959 9.959 0 0 1-7.423-9.643v-1.128l20.96-20.96c2.474-2.475 6.55-2.475 9.024 0l32.095 32.095z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "xnomfrsfda"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.667 .666)",
    d: "M0 0h87.333v87.333H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.5f46026b1ce9e92100a9bcd26c09308c.svg";
export { ForwardRef as ReactComponent };